import React from 'react';
import styled from 'styled-components';

import {
  Filter,
  FilterOption,
  FilterTypes,
  HandleChange,
} from '@/typings/filter/types';
import { Checkbox } from '@/components/Checkbox';

type Props = {
  value: string[];
  onChange: HandleChange;
  field: Filter;
  chosenFields?: {};
};

const MultiSelect = ({ field, value, onChange }: Props) => {
  const isChecked = (option: FilterOption) =>
    value.some((id) => id === option.id);

  const mapOptionToStore = (values: string[], checked: boolean, id: string) => {
    if (!checked) {
      return values.filter((value) => value !== id);
    }
    return [...values, id];
  };

  const handleChange = (option: FilterOption) => (checked: boolean) => {
    onChange({
      id: field.id,
      type: FilterTypes.MultiSelect,
      value: mapOptionToStore(value, checked, option.id),
    });
  };

  return (
    <Component>
      {field.options.map((option, index) => (
        <OptionComponent key={option.id}>
          <Checkbox
            checked={isChecked(option)}
            onChange={handleChange(option)}
          />
          <Label>{option.label}</Label>
        </OptionComponent>
      ))}
    </Component>
  );
};

export default MultiSelect;

const Component = styled.div`
  position: relative;
`;

const OptionComponent = styled.label`
  cursor: pointer;

  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 1rem;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

const Label = styled.span``;
